import {Modal} from 'bootstrap';
import {Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, OnDestroy} from '@angular/core';
import {CustomFilterPipe} from '../../../common/custom-filter.pipe';
import {IsFilterOnService} from '../../../../Services/is-filter-on.service';
import {TypeaheadBase} from '../../../common/typeahead/typeahead-base';

@Component({
  selector: 'app-item-select',
  templateUrl: './item-select.component.html',
  styleUrls: ['./item-select.component.css'],
  standalone: false
})
export class ItemSelectComponent extends TypeaheadBase implements OnInit, OnDestroy {
  @ViewChild('closeButton') closeButton: ElementRef;
  @Input() vm: any;

  @Output() updateInventoryItemEmit = new EventEmitter<string>();
  @Output() testItemEmit = new EventEmitter<string>();
  @Output() selectItemModalEmit = new EventEmitter<string>();

  constructor(public isFiltered: IsFilterOnService) {
    super();
  }

  itemTypeaheadSearch = (text$: any) => this.typeaheadSearch(text$, () => this.vm?.inventoryItemName, 15);

  ngOnInit() {
  }

  updateInventoryItem() {
    this.updateInventoryItemEmit.emit();
  }

  testItem() {
    this.testItemEmit.emit();
  }

  onItemBlur(typeahead: any) {
    if (typeahead?.isPopupOpen?.()) {
      return;
    }
    this.testItem();
  }

  selectItemModal(itemId) {
    this.selectItemModalEmit.emit(itemId);
  }

  ngOnDestroy() {
    const modalEl = this.closeButton?.nativeElement?.closest('.modal');
    if (modalEl) {
      const modal = Modal.getInstance(modalEl);
      if (modal) {
        modal.hide();
      }
    }
  }

  checkFiltered(): boolean {
    const filteredValue = this.isFiltered.isFiltered(this.vm);
    this.vm.filtered = filteredValue;
    return filteredValue;
  }
}
